export const idkStatus = {
  supportRequested: 'supportRequested',
  closed: 'closed',
}
